import React from "react";

import SrrRowBase from "./SrrRowBase";

/**
 * Содержимое таблицы UVIN: Уникальные обращения в сервис
 * @param row
 * @constructor
 */
const ReportReturnUniqueServiceTable = ({ row }) => {
  const renderItem = [
    row.name,
    row.ten_year,
    ...row.data.map(({ count }) => count),
  ];

  return <SrrRowBase cells={renderItem} />;
};

export default ReportReturnUniqueServiceTable;
